import { ExpressiveAnchorButton } from '../expressive-button/expressive-anchor-button';
import { MDSText } from '@midwest/web/base';
import { MDSVStack } from '@midwest/web/stacks';
import styled from 'styled-components';

export const Container = styled(MDSVStack)`
  background: ${(p) => p.theme.midwestColors.identityBrandPrimaryHeavy};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 2.5rem;
  padding-bottom: 1.5rem;
  max-width: 17.25rem;
  gap: 0.5rem;
`;

export const Title = styled(MDSText.BodyHeavyDefault)`
  color: ${(p) => p.theme.midwestColors.textPrimaryDarkBG};
  font-size: 1.125rem;
  line-height: 1.5rem;
`;

export const Description = styled(MDSText.BodyRegDefault)`
  color: ${(p) => p.theme.midwestColors.textPrimaryDarkBG};
  font-size: 0.875rem;
`;

export const CallToAction = styled(ExpressiveAnchorButton)`
  margin-top: 1rem;
`;
